import { useCreateToolMutation, useUploadToolCertificateMutation } from 'app/services/tools';
import { useGetUnitQuery } from 'app/services/me';
import { CreateToolRequest } from 'app/types/tool';
import ToolForm from './ToolForm';
import { Skeleton } from 'antd';
import { Paths } from 'constants/index';
import { useState } from 'react';

const CreateTool = () => {
  const { data: unit, isLoading } = useGetUnitQuery({ persist: true });

  const [ createTool, toolMeta ] = useCreateToolMutation();
  const [ uploadCertificate, fileMeta ] = useUploadToolCertificateMutation();
  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const handleSubmit = async (values: any) => {
    const createdTool = await createTool({
      unitId: unit?.Id,
      category: values.Category,
      make: values.Make,
      model: values.Model,
      serialNumber: values.SerialNumber,
      qrCode: values.QrCode,
      power: values.Power,
      airflow: values.Airflow,
      firstUsageTime: values.FirstUsageTime?.toDate(),
      isActive: values.IsActive,
    } as CreateToolRequest).unwrap();

    if (values.CertificateFile && values.CertificateFile && createdTool) {

      const fileList = values.CertificateFile as any[] | undefined;
      const first = fileList?.[0];

      if (createdTool?.Id && first) {
        await uploadCertificate({ toolId: createdTool.Id, file: first.originFileObj }).unwrap();
      }
    }
    setMeta({ isSuccess: true, data: { Id: createdTool.Id } });
  };

  if (!unit) return <Skeleton active={isLoading} />;

  return <ToolForm
    handleSubmit={handleSubmit}
    unit={unit}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: toolMeta.isLoading || fileMeta.isLoading,
      isError: toolMeta.isError || fileMeta.isError,
      data: meta.data
    }}
    redirectTo={Paths.TOOLS_VIEW}
  />;
};

export default CreateTool;
